"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var react_i18next_1 = require("react-i18next");
var react_device_detect_1 = require("react-device-detect");
var WindowSizeHook_1 = require("../Helpers/WindowSizeHook");
var proxy_1 = require("../Service/proxy");
var forms_1 = require("../../forms");
var Accordion_1 = require("../../Accordion");
require("./Styles/error-reporting.scss");
var customMessageBar_1 = require("../../customMessageBar");
function getClientInfo() {
    var device = 'Desktop';
    if (react_device_detect_1.isTablet)
        device = 'Tablet';
    else if (react_device_detect_1.isMobile)
        device = 'Mobile';
    return {
        device: device,
        os: react_device_detect_1.osName + " " + react_device_detect_1.osVersion,
        browserType: react_device_detect_1.browserName,
        browserVersion: react_device_detect_1.fullBrowserVersion
    };
}
exports.ErrorReporting = function (props) {
    var isAuthenticated = props.isAuthenticated, appVersion = props.appVersion, channel = props.channel, errorCode = props.errorCode, errorDetails = props.errorDetails, language = props.language, userId = props.userId, onSendTrace = props.onSendTrace, traceClientApiConfig = props.traceClientApiConfig, visible = props.visible, onClose = props.onClose;
    var t = react_i18next_1.useTranslation(['ErrorReporting']).t;
    var detectedSize = WindowSizeHook_1.useWindowSize();
    var readableSize = detectedSize ? detectedSize.width + "x" + detectedSize.height : '';
    var _a = react_1.useState(true), enabledEmail = _a[0], setEnabledMail = _a[1];
    var _b = react_1.useState(true), enabledClientInfo = _b[0], setEnabledClientInfo = _b[1];
    var _c = react_1.useState(false), isloading = _c[0], setIsloading = _c[1];
    var _d = react_1.useState(), title = _d[0], setTitle = _d[1];
    var _e = react_1.useState(), apiErrorMessage = _e[0], setApiErrorMessage = _e[1];
    var _f = react_1.useState(), description = _f[0], setDescription = _f[1];
    var _g = react_1.useState(), anonymousEmail = _g[0], setAnonymousEmail = _g[1];
    var clientInfo = getClientInfo();
    var sendReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var traceDTO, isCookiedEnabled, client, traceId, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setApiErrorMessage(undefined);
                    setIsloading(true);
                    traceDTO = new proxy_1.CreateTraceDto();
                    isCookiedEnabled = navigator.cookieEnabled ? 'true' : 'false';
                    traceDTO.email = isAuthenticated ? undefined : anonymousEmail;
                    traceDTO.errorCode = errorCode;
                    traceDTO.errorDetails = errorDetails;
                    traceDTO.applicationVersion = appVersion;
                    traceDTO.channelType = channel;
                    traceDTO.description = description;
                    traceDTO.title = title;
                    traceDTO.logUserId = enabledEmail;
                    traceDTO.logEmail = enabledEmail;
                    traceDTO.feedbackType = proxy_1.FeedbackType.Internal; // Review after customer confirmation 
                    traceDTO.traceLevel = proxy_1.TraceLevel.Error;
                    traceDTO.traceDateTime = new Date();
                    traceDTO.logClientProperties = enabledClientInfo;
                    traceDTO.feedbackType = channel === proxy_1.ChannelTypes.AdminPortal ? proxy_1.FeedbackType.Internal : proxy_1.FeedbackType.External;
                    traceDTO.clientProperties = {
                        'OS': enabledClientInfo ? clientInfo.os : '',
                        'CookiesEnabled': enabledClientInfo ? isCookiedEnabled : '',
                        'BrowserType': enabledClientInfo ? clientInfo.browserType : '',
                        'BrowserInformation': enabledClientInfo ? clientInfo.browserVersion : '',
                        'Device': enabledClientInfo ? clientInfo.device : '',
                        'ScreenSize': enabledClientInfo ? readableSize : '',
                        'UILanguage': enabledClientInfo ? props.language : ''
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    client = new proxy_1.TraceClient(traceClientApiConfig);
                    return [4 /*yield*/, client.trace(traceDTO)];
                case 2:
                    traceId = _b.sent();
                    setIsloading(false);
                    onSendTrace(traceId);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setIsloading(false);
                    if (((_a = error_1.serviceError) === null || _a === void 0 ? void 0 : _a.details) && error_1.serviceError.details.length > 0) {
                        setApiErrorMessage(error_1.serviceError.details[0].message);
                    }
                    else if (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) {
                        setApiErrorMessage(error_1.message);
                    }
                    else {
                        setApiErrorMessage(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleClientInfo = function () {
        setEnabledClientInfo(!enabledClientInfo);
    };
    return (react_1.default.createElement(forms_1.Dialog, { loadingText: isloading ? t('common:loading') : undefined, containerClassName: 'dialog', hidden: !visible, onDismiss: function () {
            onClose();
        }, maxWidth: 720, title: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Icon, { className: 'eta-popup-HeaderIcon', iconName: 'MailForward' }),
            t('ErrorReporting:Name'))) },
        react_1.default.createElement(customMessageBar_1.MessageBar, { messageBarType: react_2.MessageBarType.error, hidden: !apiErrorMessage, onDismiss: function () { return setApiErrorMessage(undefined); } }, apiErrorMessage !== null && apiErrorMessage !== void 0 ? apiErrorMessage : ''),
        react_1.default.createElement("div", { className: 'eta-popup-scrollable' },
            react_1.default.createElement(forms_1.TextField, { label: t('ErrorReporting:Title'), required: true, autoFocus: true, errorMessage: title === '' ? t('ErrorReporting:ValidationError') : '', value: title, onChange: function (_, val) { return setTitle(val); } }),
            react_1.default.createElement(forms_1.TextField, { multiline: true, label: t('ErrorReporting:Description'), value: description, onChange: function (_, val) { return setDescription(val); } }),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", null,
                " ",
                t('ErrorReporting:UserConsent'),
                " "),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: 'toggle-container' },
                react_1.default.createElement(react_2.Toggle, { className: 'toggle-ctrl', checked: enabledEmail, onChange: function () { return setEnabledMail(!enabledEmail); } }),
                react_1.default.createElement("div", { className: 'toggle-txt', hidden: !isAuthenticated },
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            " ",
                            t('ErrorReporting:UserId'),
                            ":  "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' }, userId))),
                react_1.default.createElement("div", { className: 'toggle-txt', hidden: isAuthenticated },
                    react_1.default.createElement(forms_1.TextField, { prefix: t('ErrorReporting:Email') + ":", value: anonymousEmail, onChange: function (_, val) { return setAnonymousEmail(val); }, disabled: !enabledEmail }))),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: 'toggle-container' },
                react_1.default.createElement(react_2.Toggle, { className: 'toggle-ctrl', checked: enabledClientInfo, onChange: function () { return handleClientInfo(); } }),
                react_1.default.createElement("div", { className: 'toggle-txt' },
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            " ",
                            t('ErrorReporting:DeviceType'),
                            ": "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' }, clientInfo.device)),
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            "  ",
                            t('ErrorReporting:OS'),
                            ": "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' }, clientInfo.os)),
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            "  ",
                            t('ErrorReporting:Browser'),
                            ": "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' },
                            clientInfo.browserType,
                            " ",
                            clientInfo.browserVersion)),
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            "  ",
                            t('ErrorReporting:ScreenSize'),
                            ": "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' }, readableSize)),
                    react_1.default.createElement("div", { className: 'line-container' },
                        react_1.default.createElement("div", { className: 'line-lbl' },
                            "  ",
                            t('ErrorReporting:Language'),
                            ": "),
                        " ",
                        react_1.default.createElement("div", { className: 'line-txt' }, language === 'ar' ? t('ErrorReporting:Arabic') : t('ErrorReporting:English'))))),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(Accordion_1.Accordion, { title: t('ErrorReporting:Details'), alwaysVisibleChildren: (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: 'line-lbl' }, t('ErrorReporting:ErrorCode')),
                    react_1.default.createElement("div", null, errorCode))) },
                react_1.default.createElement("div", { className: 'line-lbl' }, t('ErrorReporting:ErrorDescription')),
                react_1.default.createElement("div", null, errorDetails)),
            react_1.default.createElement("div", { className: 'line-lbl padding' },
                t('ErrorReporting:DisclaimerLable'),
                ":"),
            react_1.default.createElement("div", { className: 'line-txt-light' },
                " ",
                t('ErrorReporting:Disclaimer')),
            react_1.default.createElement("br", null)),
        react_1.default.createElement("div", { className: 'btns-container' },
            react_1.default.createElement(react_2.DefaultButton, { text: t('ErrorReporting:Cancel'), onClick: function () {
                    onClose();
                } }),
            react_1.default.createElement(react_2.PrimaryButton, { disabled: title === undefined || title === '', text: t('ErrorReporting:Send'), iconProps: { iconName: 'Send' }, onClick: function () {
                    sendReport();
                } }))));
};
//# sourceMappingURL=ErrorReporting.js.map